var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A36",
    fillRule: "evenodd",
    d: "M2.5 2.583c-.43 0-.833.35-.833.917v1.917c0 .09.038.283.146.523a1.94 1.94 0 0 0 .375.57l3.166 3.333a.828.828 0 0 1 .047.053c.226.283.431.649.581 1.024.148.37.268.813.268 1.247v4.416c0 .63.738 1.056 1.307.71l1.159-.744a.908.908 0 0 1 .022-.014c.032-.018.128-.105.22-.284.09-.174.125-.333.125-.418V12.25a3.6 3.6 0 0 1 .296-1.377c.18-.423.453-.855.827-1.171l3.553-3.14a2.28 2.28 0 0 0 .389-.605c.125-.276.185-.53.185-.707V3.417a.838.838 0 0 0-.833-.834h-11ZM0 3.5C0 2.067 1.097.917 2.5.917h11c1.377 0 2.5 1.123 2.5 2.5V5.25c0 .49-.148.986-.335 1.397a3.869 3.869 0 0 1-.78 1.144l-3.583 3.167a.94.94 0 0 1-.018.016c-.12.1-.26.289-.371.55a1.952 1.952 0 0 0-.163.726v3.583c0 .416-.132.84-.313 1.187-.176.338-.45.705-.829.937l-1.157.744-.014.009c-1.596.982-3.854-.092-3.854-2.127v-4.416c0-.15-.047-.374-.148-.628a2.567 2.567 0 0 0-.317-.577L.986 7.664a3.596 3.596 0 0 1-.694-1.042C.129 6.26 0 5.826 0 5.417V3.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorBlack);
export default __webpack_public_path__ + "static/media/Vector_black.7578e3fb02fe05cd28609fe05c94e11c.svg";
export { ForwardRef as ReactComponent };